// One workspace's settings: what applies there (`effective`) and what the workspace overrode of its
// organization's (`overrides`, `null` on every field it inherits). One resource, read, patched and
// reset whole; the organization's own level is `../orgs/assetSettings`.

import { api } from '../client'
import type { components } from '../schema'

export type WorkspaceAssetSettingsView = components['schemas']['WorkspaceAssetSettingsView']
export type UpdateWorkspaceAssetSettingsRequest = components['schemas']['UpdateWorkspaceAssetSettingsRequest']
export type EffectiveAssetSettings = components['schemas']['EffectiveAssetSettings']
export type AssetSettingsOverrides = components['schemas']['AssetSettingsOverrides']

function settingsPath(workspaceId: string): string {
  return `/workspaces/${encodeURIComponent(workspaceId)}/asset-settings`
}

/** The workspace's settings, readable with a seat in it. */
export function getWorkspaceAssetSettings(
  workspaceId: string,
  signal?: AbortSignal,
): Promise<WorkspaceAssetSettingsView> {
  return api.get<WorkspaceAssetSettingsView>(settingsPath(workspaceId), undefined, signal)
}

/**
 * Override settings on the workspace: a field with a value overrides, a field sent as `null`
 * inherits again, a field left out is left alone. 400 for an effective state the product refuses —
 * advertising on with no VAST tag anywhere in the chain. Needs `assets.workspace.manage`.
 */
export function updateWorkspaceAssetSettings(
  workspaceId: string,
  request: UpdateWorkspaceAssetSettingsRequest,
): Promise<WorkspaceAssetSettingsView> {
  return api.patch<WorkspaceAssetSettingsView>(settingsPath(workspaceId), request)
}

/** Stop overriding anything: every setting inherits again. Idempotent. */
export function resetWorkspaceAssetSettings(workspaceId: string): Promise<undefined> {
  return api.del<undefined>(settingsPath(workspaceId))
}
